import { Image } from '@app/components'
import React from 'react'

export const BankIcon: React.FC<{ height?: number }> = ({ height = 30 }) => {
  return <Image preview={false} src="../images/Bank-Icon.png" style={{ height }} />
}
